// 手机号验证
export function checkPhone (rule, value, callback) {
  console.log(rule, 'checkPhone')
  if (value && value !== '') {
    const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的手机号'))
    }
  } else {
    callback()
  }
}

export function checkQq (rule, value, callback) {
  if (value && value !== '') {
    const reg = /[1-9][0-9]{4,14}/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的qq号码'))
    }
  } else {
    callback()
  }
}

export function checkPwd (rule, value, callback) {
  if (value && value !== '') {
    const reg = /^[0-9a-zA-Z]*$/
    if (reg.test(value) && value.length <= 20) {
      callback()
    } else {
      return callback(new Error('请输入不超过20位的只包含数字或字母'))
    }
  } else {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js